import { NavLink } from 'react-router-dom'
import styled from 'styled-components'

export const NavbarContainer = styled.nav`
    height: 80px;
    width: 100%;
    background-color: #fff;
    align-items: center;
    display: flex;
    justify-content: center;
    position: fixed; /* mindig látszik */
    top: 0; /* a lap tetején */
    left: 0;
    z-index: 1000;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1); /* opcionális árnyék */
`
export const NavbarWrapper = styled.div`
    height: 100%;
    width: 100%;
    max-width: 1600px;
    padding: 0 20px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin: auto;
    position: relative;

    @media (max-width: 768px) {
        justify-content: center;
        padding: 0 15px;
    }
`

export const Left = styled.div`
    display: flex;
    align-items: center;

    @media (max-width: 768px) {
        position: absolute;
        left: 15px;
    }
`

export const Center = styled.div`
    display: flex;
    justify-content: center;
    flex: 1;

    @media (min-width: 769px) {
        justify-content: flex-start;
    }
`

export const Right = styled.div`
    display: flex;
    align-items: center;

    @media (max-width: 768px) {
        position: absolute;
        right: 15px;
    }
`

export const Logo = styled.img`
    max-height: 105px;
    max-width: 225px;
    cursor: pointer;

    @media (max-width: 768px) {
        max-height: 84px;
        max-width: 180px;
    }
`

interface NavLinksProps {
    ismobilemenuopen: boolean
}

export const NavLinks = styled.div.withConfig({
    shouldForwardProp: (prop) => prop !== 'ismobilemenuopen',
})<NavLinksProps>`
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    @media (max-width: 768px) {
        display: ${(props) => (props.ismobilemenuopen ? 'flex' : 'none')};
        flex-direction: column;
        width: 50%;
        background-color: #fff;
        position: absolute;
        top: 60px;
        left: 50%;
        padding: 10px 15px;
        box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
        z-index: 1000;
        gap: 1rem;
    }
`

export const CustomNavLink = styled(NavLink)`
    font-family: 'Poppins', sans-serif;
    font-size: 12px;
    font-weight: normal;
    color: #000;
    text-decoration: none;
    margin-right: 20px;
    padding: 0 10px;

    &:last-child {
        margin-right: 0;
    }

    &.active {
        font-weight: bold;
        color: #685612;
    }

    @media (max-width: 768px) {
        margin: 10px 0;
    }
`

export const UsernameContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 10px;
    margin-top: 1rem;
`

export const UserIcon = styled.i`
    font-size: 20px;
    color: #888888;
`

export const Username = styled.p`
    font-size: 12px;
    color: #888888;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 12ch;
    font-weight: bold;
    margin-top: 4px;
`

export const HamburgerIcon = styled.div`
    display: none;
    cursor: pointer;
    font-size: 30px;
    color: #000;

    @media (max-width: 768px) {
        display: block;
    }
`

export const SuperAdminBar = styled.div`
    width: 100%;
    background-color: #d32f2f;
    color: white;
    font-weight: bold;
    text-align: center;
    padding: 0.5rem 0;
    font-size: 0.875rem;
    position: fixed; /* sticky a navbar alatt */
    top: 80px; /* közvetlenül a navbar alatt */
    left: 0;
    z-index: 999;
`
